export const calculateIncrementalReturn = (monthlyTarget: number, nextWithdrawalDate: string | Date) => {
    const now = new Date();
    const targetDate = new Date(nextWithdrawalDate);

    // 1. Calculate the start of the current 30-day cycle
    const cycleStartDate = new Date(targetDate);
    cycleStartDate.setDate(targetDate.getDate() - 30);

    // 2. Calculate total duration and elapsed time in milliseconds
    const totalCycleMs = targetDate.getTime() - cycleStartDate.getTime();
    const elapsedMs = now.getTime() - cycleStartDate.getTime();

    // 3. Calculate the progress fraction (capped between 0 and 1)
    const progressFraction = Math.max(0, Math.min(1, elapsedMs / totalCycleMs));

    // 4. Calculate values
    const accruedSoFar = monthlyTarget * progressFraction;

    // Daily percentage remains relative to the total (1/30th of the target)
    const dailyPercentage = (1 / 30) * 100;

    return {
        accruedSoFar,
        dailyPercentage: dailyPercentage.toFixed(1),
        isCycleComplete: progressFraction === 1
    };
};